export default __webpack_public_path__ + "static/media/newblp_Workspaces.bc78bf6e.svg";